<template>
  <div class="c-contact-us">
    <Select
      :id="contactUsSelect"
      label="Please select"
      :options="selectOptions"
      @change="setActivePanel"
      v-if="!activePanel"
    ></Select>

    <template v-for="panel in panels">
      <accordion-container
        :key="panel.index"
        v-if="activePanel && activePanel.title === panel.title"
        @selectionEdited="resetActivePanel"
      >
        <accordion-panel
          :editLabel="content.editPanelLabel"
          :editLabelMobile="content.editPanelLabelMobile"
          :key="index"
          :title="panel.title"
          :is-active="true"
          @active="setActivePanel"
          :is-expanded="isPanelExpanded(panel)"
          @setCurrentPanel="resetActivePanel"
        >
          <icon-list
            :items="panel.children"
            v-if="showIconList(panel)"
            @click="setCurrentPanel"
          ></icon-list>
          <report-problem
            v-if="showRap(panel)"
            :componentId="rapComponentId"
            :config="panel.rapConfig"
            :questions="rapQuestions"
            :content="rapContent"
            :journey="currentPanel"
            :user="user"
          />
          <content-template
            v-if="showContentTemplate(panel)"
            :config="panel.config"
          />
        </accordion-panel>

        <template v-for="levelTwo in panel.children">
          <accordion-panel
            :editLabel="content.editPanelLabel"
            :editLabelMobile="content.editPanelLabelMobile"
            :key="levelTwo.index"
            :title="levelTwo.title"
            :is-active="isPanelActive(levelTwo)"
            :is-expanded="isPanelExpanded(levelTwo)"
            @setCurrentPanel="setCurrentPanel(panel.title)"
          >
            <icon-list
              :items="levelTwo.children"
              v-if="showIconList(levelTwo)"
              @click="setCurrentPanel"
            ></icon-list>
            <report-problem
              v-if="showRap(levelTwo)"
              :componentId="rapComponentId"
              :config="levelTwo.rapConfig"
              :questions="rapQuestions"
              :content="rapContent"
              :journey="currentPanel"
              :user="user"
            />
            <content-template
              v-if="showContentTemplate(levelTwo)"
              :config="levelTwo.config"
            />
          </accordion-panel>

          <accordion-panel
            v-for="levelThree in levelTwo.children"
            :editLabel="content.editPanelLabel"
            :editLabelMobile="content.editPanelLabelMobile"
            :key="levelThree.index"
            :title="levelThree.title"
            :is-active="isPanelActive(levelThree)"
            :is-expanded="isPanelExpanded(levelThree)"
            @setCurrentPanel="setCurrentPanel(levelTwo.title)"
          >
            <icon-list
              :items="levelThree.children"
              v-if="showIconList(levelThree)"
              @click="setCurrentPanel"
            ></icon-list>

            <report-problem
              v-if="showRap(levelThree)"
              :componentId="rapComponentId"
              :config="levelThree.rapConfig"
              :questions="rapQuestions"
              :content="rapContent"
              :journey="currentPanel"
              :user="user"
            />
            <content-template
              v-if="showContentTemplate(levelThree)"
              :config="levelThree.config"
            />
          </accordion-panel>
        </template>
      </accordion-container>
    </template>
  </div>
</template>

<script>
  import AccordionContainer from "./AccordionContainer.vue";
  import AccordionPanel from "./AccordionPanel.vue";
  import IconList from "./IconList.vue";
  import Select from "../../forms/select/SelectDropdown.vue";
  import ReportProblem from "../../_contact-us-rap/_vue/ReportProblem.vue";
  import ContentTemplate from "./ContentTemplate.vue";

  export default {
    name: "ContactUs",
    components: {
      AccordionContainer,
      AccordionPanel,
      ContentTemplate,
      IconList,
      ReportProblem,
      Select,
    },
    props: {
      user: {
        type: Object,
      },
      content: {
        type: Object,
        required: true,
      },
      panels: {
        type: Object,
        required: true,
      },
      rapComponentId: {
        type: String,
        required: true,
      },
      rapContent: {
        required: false,
        type: Object,
      },
      rapQuestions: {
        type: Array,
        required: false,
      },
    },
    data() {
      return {
        activePanel: null,
        currentPanel: null,
      };
    },
    computed: {
      selectOptions() {
        const panelTitles = new Set(this.panels.map((panel) => panel.title));
        return Array.from(panelTitles).map((title) => ({
          value: title,
          label: title,
        }));
      },
    },
    methods: {
      isPanelExpanded(panel) {
        return panel.title === this.currentPanel;
      },
      showIconList(panel) {
        return panel.type === "icon-list";
      },
      showRap(panel) {
        return panel.type === "rap" && this.rapContent && this.rapQuestions;
      },
      showContentTemplate(panel) {
        return panel.type === "content-template";
      },
      isPanelActive(panel) {
        if (!this.currentPanel) return false;
        if (panel.title === this.currentPanel) return true;
        if (
          this.currentPanel === panel.title ||
          (panel.children &&
            panel.children.find((panel) => panel.title === this.currentPanel))
        )
          return true;
      },
      setActivePanel(option) {
        this.currentPanel = option.value;
        this.activePanel = this.panels.find(
          (panel) => panel.title === this.currentPanel
        );
      },
      setCurrentPanel(value) {
        this.currentPanel = value;
        const el = document.getElementsByClassName('js-active-accordion-panel')[0];
        el.scrollIntoView({ behavior: "smooth" });
      },
      resetActivePanel() {
        this.activePanel = null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/contact-us/_vue/ContactUs.vue